import managerTypes from './manager.types';
import axios from 'axios';
import Socket from 'socket.io-client';
import storage from '../../helpers/storage';

let url;
if (process.env.VUE_APP_NODE_ENV == 'production') {
  url = `${process.env.VUE_APP_API_LIVE_URI}/workspace`;
} else {
  url = `${process.env.VUE_APP_API_TEST_URI}/workspace`;
}

const io = Socket(url);

export default {
  updateWelcome({ commit }) {
    const ls = storage.get('manager');
    // commit(managerTypes.FETCH_WELCOME_REQUEST);

    const options = {
      url: `${url}/update`,
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${ls.token}`
      },
      data: {
        first_name: ls.first_name,
        last_name: ls.last_name,
        wizardComplete: true
      }
    };
    axios(options)
      .then(res => {
        commit(managerTypes.FETCH_WELCOME_SUCCESS, {
          data: { welcome: res.data.manager.wizardComplete }
        });
      })
      .catch(err => {
        commit(managerTypes.FETCH_WELCOME_FAILED);

      });
  },
  fetchAllEmployees({ commit }) {
    commit(managerTypes.FETCH_manager_REQUEST);
    const ls = storage.get('manager');

    const options = {
      url: `${url}/admins/all?resultSize=1000&page=1`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${ls.token}`
      }
    };
    axios(options)
      .then(res => {
        commit(managerTypes.FETCH_manager_SUCCESS, {
          data: { employees: res.data.admins.docs}
        });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(managerTypes.FETCH_manager_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(managerTypes.FETCH_manager_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(managerTypes.FETCH_manager_FAILED, { error });
      });
  },
  uploadsupporters({ commit }, supporters) {
    commit(managerTypes.UPLOAD_SUPPORTERS_REQUEST);
    const manager = storage.get('manager');
    axios
      .post(
        `${url}/upload-supporters`,
        { supporters },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${manager.token}`
          }
        }
      )
      .then(() => {
        commit(managerTypes.UPLOAD_SUPPORTERS_SUCCESS);
        //io.emit('fetch supporters', { manager_email: manager.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, { error });
      });
  },
  addEmployee({ commit }, supporters) {
    commit(managerTypes.UPLOAD_SUPPORTERS_REQUEST);
    const manager = storage.get('manager');
    axios
      .post(
        `${url}/upload-supporters`,
        { supporters },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${manager.token}`
          }
        }
      )
      .then(() => {
        commit(managerTypes.UPLOAD_SUPPORTERS_SUCCESS);
        //io.emit('fetch supporters', { manager_email: manager.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, { error });
      });
  },
  addSupporter({ commit }, supporters) {
    commit(managerTypes.UPLOAD_SUPPORTERS_REQUEST);
    const manager = storage.get('manager');
    axios
      .post(
        `${url}/upload-supporters`,
        { supporters },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${manager.token}`
          }
        }
      )
      .then(() => {
        commit(managerTypes.UPLOAD_SUPPORTERS_SUCCESS);
        //io.emit('fetch supporters', { manager_email: manager.email });
      })
      .catch(err => {
        if (!err.status && !err.response) {
          return commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, {
            error: 'Network error'
          });
        }
        if (err && err.response && err.response.status === 404) {
          return commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, {
            error: err.response.statusText
          });
        }
        //handle payment error
        const error = err.response.data.error;
        commit(managerTypes.UPLOAD_SUPPORTERS_FAILED, { error });
      });
  }
};
